// import 'babel-polyfill'
import Vue from 'vue'
// import './plugins/vuetify'
import '../node_modules/vuetify/dist/vuetify.min.css';
import App from './App.vue'
import axios from 'axios';
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router';
import {routes} from './routes';
import store from './store';
import Helper from './plugins/helper';
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)
window.axios = require('axios');
Vue.use(VueAxios, axios);
Vue.use(VueRouter);
Vue.use(Helper);

require('@/assets/css/app.css')

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)

axios.interceptors.request.use(function (config) {
  if (config.url.startsWith('https://web-admin.sum.ba')){
    config.headers.accept = "application/json";
    config.headers.language = 'hr';
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

const router = new VueRouter ({
  routes,
  linkExactActiveClass: "active",
  mode: 'history',
});

export const serverBus = new Vue();
Vue.use(serverBus);

Vue.config.productionTip = false

new Vue({
  vuetify: new Vuetify(),
  render: h => h(App),
  router,
  store
}).$mount('#app')
